import { useDispatch } from 'react-redux';
import _ from 'lodash';
import {
  getDetailedFlightData,
  getDetailedHotelData,
  getDetailedCarData,
  getDetailedCruiseData,
  getDetailedTourData,
} from '../introMessages';
import isQuerySensitive from './isQuerySensitive';
import { updateBrochureField } from '../../../store/slices/brochure';

export const updateGeneralInfo = (itinerary, generalInfo) => {
  const currencyCode = (itinerary.cost && itinerary.cost.currencyCode) || 'USD';
  switch (itinerary.mode) {
    case 0:
      return `${generalInfo}${getDetailedFlightData(itinerary, currencyCode)}\n\n`;
    case 5:
      return `${generalInfo}${getDetailedHotelData(itinerary.hotel, currencyCode)}\n\n`;
    case 15:
      return `${generalInfo}${getDetailedCruiseData(_.cloneDeep(itinerary.itineraryDetail), _.cloneDeep(itinerary.cabinCategories))}\n\n`;
    case 17:
      return `${generalInfo}${getDetailedTourData(itinerary, currencyCode)}\n\n`;
    default:
      return `${generalInfo}${getDetailedCarData(itinerary, currencyCode)}\n\n`;
  }
};

export const useBrochureFunctions = (brochure, doShowChatGPTBrochureMsgInput) => {
  const dispatch = useDispatch();

  if (!brochure || !doShowChatGPTBrochureMsgInput) {
    return { generalInfo: '', brochureUtilFunctions: {} };
  }
  let generalInfo = brochure && '';
  const keys = brochure && Object.keys(brochure.trips);
  const trips = brochure && brochure.trips;

  const processTripSegments = (tripSegments) => {
    tripSegments.forEach(({ itinerary }) => {
      generalInfo = updateGeneralInfo(itinerary, generalInfo);
    });
  };

  for (let index = 0; index < keys.length; index += 1) {
    const { tripSegments } = trips[keys[index]];
    processTripSegments(tripSegments);
  }

  const brochureUtilFunctions = {
    isQueryRelevant: () => null,
    isQuerySensitive: (query) => isQuerySensitive(query),
    resetEmailMessage: (updatedEmailMessage) => {
      dispatch(updateBrochureField({ fieldName: 'emailMessage', fieldValue: updatedEmailMessage }));
    },
  };

  return { generalInfo, brochureUtilFunctions };
};
